var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.5,
    height: 27.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2188",
    transform: "translate(-16.75 -624.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 101",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(17.5 625.5)",
    fill: "none",
    stroke: "#00b8f1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4370",
    d: "M28.866 633.142a1.611 1.611 0 001.653 1.56 1.578 1.578 0 001.615-1.56 1.562 1.562 0 00-1.615-1.54 1.6 1.6 0 00-1.653 1.54zm2.983 4.37a1.259 1.259 0 00-1.33-1.178 1.3 1.3 0 00-1.33 1.178v6.707a1.3 1.3 0 001.33 1.178 1.259 1.259 0 001.33-1.178z",
    fill: "#fff"
  }))));
}

export default SvgIconInfo;